import ReactPixel from 'react-facebook-pixel';

import HashCode from './HashCode';
import { getUserKey, setUserKey } from './SettingsRetriever';

const debug = true;
let sessionId = getUserKey();

export const initFBPX = (settings) => {
    let fbpxConfiguration = {};
    let timestamp = parseInt(new Date().getTime() / 1000);

    if(sessionId) {
        if( (sessionId.timestamp + 3600) < timestamp ) {
            sessionId = false;
        }
    }

    if(!sessionId || !sessionId.timestamp) {
        sessionId = {
            id: HashCode(window.document.location.host+'+'+(timestamp)+'*'),
            timestamp: timestamp
        };
    }else{
        sessionId.timestamp = timestamp;
    }

    setUserKey(sessionId);

    if(settings && settings.analytics) {
        if(settings.analytics.fbpx) {
            fbpxConfiguration = settings.analytics.fbpx;
        }
    }

    if(fbpxConfiguration.code) {
        const advancedMatching = {}; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
        const options = {
            autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
            debug: false, // enable logs
            currency: fbpxConfiguration.currency
        };

        ReactPixel.init(fbpxConfiguration.code, advancedMatching, options);
        if(debug){
            console.log('ReactPixel', fbpxConfiguration.code);
        }
    }
}

export const track = (data) => {
    const settings = data.globalSettings;
    const section = data.event;
    const trackData = data.data;

    if(settings && settings.analytics && settings.analytics.fbpx && settings.analytics.fbpx.code) {
        const fbpxConfig = settings.analytics.fbpx;

        if(fbpxConfig.sections[section]) {
            let options = {};

            if(section === 'completed-booking') {
                options = {
                    currency: fbpxConfig.currency,
                    value: trackData.total
                }
            }

            ReactPixel.track(fbpxConfig.sections[section], options);
            if(debug) {
                console.log('ReactPixel Track', trackData);
            }
        }
    }
}